import { AmbassadorThird } from '../../../enums';
import { AmbassadorToggleMolecule } from '../../molecules/';
import LazyLoad from 'react-lazyload';

export const AmbassadorDesktopLookingInfluenceOrganism = () => {
  return (
    <div className="w-full block mt-32">
      <div className="flex flex-row mt-11 w-4/5 max-w-screen-lg mx-auto ">
        <div className="w-2/5 relative flex flex-row items-end ">
          <div>
            <div className="flex w-full items-start justify-end -mt-6 -mr-5">
              <LazyLoad offset={100}>
                <img src="/images/ambassadors/desktop/_DSC2431-5.png" />
              </LazyLoad>
            </div>
          </div>
        </div>
        <div className="block flex flex-col items-start  w-3/5">
          <h2 className="text-4xl leading-10 w-full">
            <span className="underline">We’re looking for</span>&nbsp;
            {AmbassadorThird.THIRD_TITLE}
          </h2>
          <div className="block flex flex-col w-full  min-w-min pl-0 mb-10">
            <AmbassadorToggleMolecule
              title={AmbassadorThird.DEVELOP_TITLE}
              content={AmbassadorThird.DEVELOP_DESC}
              display=" mb-24 lg:mb-18"
              boxStyling="w-full -ml-6"
            />
            <AmbassadorToggleMolecule
              title={AmbassadorThird.PROMOTE_TITLE}
              content={AmbassadorThird.PROMOTE_DESC}
              display="-ml-10 mb-24 lg:mb-18"
              boxStyling="w-full -ml-16"
            />
            <AmbassadorToggleMolecule
              title={AmbassadorThird.EDUCATE_TITLE}
              content={AmbassadorThird.EDUCATE_DESC}
              display="-ml-20 mb-24 lg:mb-18"
              boxStyling="w-full -ml-28"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
